import {axios} from '@/utils'
import UserService from '@/services/User.js'
import metric_message from "@/domain/metrics/message";


const user = JSON.parse(localStorage.getItem('user')) || ''
if (user) {
    metric_message.setUserId(user.id)
}

const state = {
    token: localStorage.getItem('token') || '',
    token_type: localStorage.getItem('token_type') || '',
    user: user
}

const getters = {
    isAuthenticated: state => !!state.token,
    hasAcceptedRequiredPolicies: state => !!state.user.accepted_required_policies,
    currentUser: state => state.user,
    hasPerm: (state) => (perm) => state.user && state.user.perms && state.user.perms.indexOf(perm) !== -1,
    token: state => state.token,
    tokenType: state => state.token_type,
}

const mutations = {
    SET_TOKEN(state, {token, token_type, remember = true}) {
        state.token = token
        state.token_type = token_type
        axios.defaults.headers.common['Authorization'] = `${token_type} ${token}`
        if (remember) {
            localStorage.setItem('token', token)
            localStorage.setItem('token_type', token_type)
        }
    },

    SET_USER(state, {user, remember = true}) {
        state.user = user
        metric_message.setUserId(user.id)
        if (remember)
            localStorage.setItem('user', JSON.stringify(user))
    },

    LOGOUT(state) {
        state.token = ''
        state.token_type = ''
        state.user = ''
        this.commit('CLEAR_CUSTOM_MODAL_CHECKIN_DETAIL_SHOWN', null, {root: true})
        this.commit('checkinDetail/clean_popup_viewed')
        metric_message.setUserId(null)
        localStorage.removeItem('token')
        localStorage.removeItem('token_type')
        localStorage.removeItem('user')
        localStorage.removeItem('eventOwnerId')
        localStorage.removeItem('customModalCheckinDetailShown')
        delete axios.defaults.headers.common['Authorization']
        delete axios.defaults.headers.common['Pica-Event-Owner-Id']
    },
}


const actions = {
    login({commit}, user) {
        return new Promise((resolve, reject) => {
            UserService.getAuthToken(user.email, user.password)
                .then(response => {
                    commit('SET_TOKEN', {
                        token: response.data.token,
                        token_type: 'Token'
                    })
                    resolve(response)
                })
                .catch(error => {
                    commit('LOGOUT')
                    reject(error)
                })
        })
    },

    loginWithJwt({commit}, token) {
        commit('SET_TOKEN', {
            token: token,
            token_type: 'Bearer'
        })
    },

    ssoLogin({commit}, {integration_id, token}) {
        return new Promise((resolve, reject) => {
            UserService.getTokenFromSsoLogin(integration_id, token).then(response => {
                commit('SET_TOKEN', {
                    token: response.data.token,
                    token_type: 'Token'
                })
                resolve(response.data)
            }).catch(error => {
                commit('LOGOUT')
                reject(error)
            })
        })
    },

    socialLogin({commit}, data) {
        return new Promise((resolve, reject) => {

            UserService.convertAuthToken(data).then(response => {
                commit('SET_TOKEN', {
                    token: response.data.access_token,
                    token_type: response.data.token_type
                })
                resolve(response)
            }).catch(error => {
                commit('LOGOUT')
                reject(error)
            })
        })
    },

    ibiLogin({commit}, data) {
        return new Promise((resolve, reject) => {
            UserService.convertIbiAuthToken(data).then(response => {
                commit('SET_TOKEN',  {
                    token: response.data.access_token,
                    token_type: response.data.token_type
                })
                resolve(response)
            }).catch(error => {
                commit('LOGOUT')
                reject(error)
            })
        })
    },


    getCurrentUser({commit}, remember = true) {
        return UserService.getUserData()
            .then(response => {
                const user = response.data
                commit('SET_USER', {
                    user: user,
                    remember: remember
                })
                return response
            })
            .catch(function (error) {
                // console.log(error)
                return error
            })
    },

    logout({commit}) {
        return new Promise((resolve) => {
            commit('LOGOUT')
            resolve()
        })
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}